export default __webpack_public_path__ + "static/media/guitar_tricks_button.762b7d8d.png";